module.exports = __webpack_public_path__ + "img/motor_no47.fe20dc1b.jpg";